import { LineOfBusiness } from './domain.models';

export const COVERAGE_LEVELS: Record<LineOfBusiness, string[]> = {
  auto: ['Responsabilidad Civil', 'Terceros Completo', 'Todo Riesgo con franquicia', 'Todo Riesgo'],
  home: ['Básico', 'Intermedio', 'Completo'],
  commerce: ['Básico', 'Integral'],
  liability: ['Suma asegurada básica', 'Suma asegurada ampliada'],
  'personal-accident': ['Capital estándar', 'Capital ampliado'],
  life: ['Capital estándar', 'Capital ampliado'],
};

export interface CoverageDef {
  name: string;
  /** Lowest level index (in `COVERAGE_LEVELS`) that includes this coverage. */
  minLevel: number;
}

/** Illustrative coverage matrix: a coverage is included from `minLevel` upwards. */
export const COVERAGE_CATALOG: Record<LineOfBusiness, CoverageDef[]> = {
  auto: [
    { name: 'Responsabilidad civil', minLevel: 0 },
    { name: 'Robo total', minLevel: 1 },
    { name: 'Incendio total', minLevel: 1 },
    { name: 'Auxilio mecánico', minLevel: 1 },
    { name: 'Robo parcial', minLevel: 2 },
    { name: 'Incendio parcial', minLevel: 2 },
    { name: 'Destrucción total', minLevel: 2 },
    { name: 'Daños parciales', minLevel: 2 },
    { name: 'Cristales', minLevel: 2 },
    { name: 'Granizo', minLevel: 3 },
    { name: 'Cerraduras', minLevel: 3 },
    { name: 'Auto sustituto', minLevel: 3 },
  ],
  home: [
    { name: 'Incendio de edificio', minLevel: 0 },
    { name: 'Incendio de contenido', minLevel: 0 },
    { name: 'Robo en la vivienda', minLevel: 1 },
    { name: 'Daños por agua', minLevel: 1 },
    { name: 'Cristales', minLevel: 1 },
    { name: 'Responsabilidad civil hechos privados', minLevel: 2 },
    { name: 'Granizo y tormenta', minLevel: 2 },
  ],
  commerce: [
    { name: 'Incendio', minLevel: 0 },
    { name: 'Robo de mercadería', minLevel: 0 },
    { name: 'Daños por agua', minLevel: 1 },
    { name: 'Responsabilidad civil comercial', minLevel: 1 },
    { name: 'Cristales y letreros', minLevel: 1 },
    { name: 'Lucro cesante', minLevel: 1 },
  ],
  liability: [
    { name: 'RC por daños a terceros', minLevel: 0 },
    { name: 'Defensa en juicio', minLevel: 0 },
    { name: 'RC cruzada', minLevel: 1 },
    { name: 'Daños a bienes bajo custodia', minLevel: 1 },
  ],
  'personal-accident': [
    { name: 'Muerte accidental', minLevel: 0 },
    { name: 'Invalidez permanente', minLevel: 0 },
    { name: 'Gastos médicos', minLevel: 1 },
    { name: 'Asistencia en viaje', minLevel: 1 },
  ],
  life: [
    { name: 'Muerte por cualquier causa', minLevel: 0 },
    { name: 'Invalidez total y permanente', minLevel: 1 },
    { name: 'Enfermedades graves', minLevel: 1 },
  ],
};

export function levelIndex(line: LineOfBusiness, level: string | null | undefined): number {
  const index = COVERAGE_LEVELS[line].indexOf(level ?? '');
  return index < 0 ? 0 : index;
}

export function coverageIncluded(line: LineOfBusiness, level: string | null | undefined, def: CoverageDef): boolean {
  return levelIndex(line, level) >= def.minLevel;
}

export function mainCoverages(line: LineOfBusiness, level: string | null | undefined): string[] {
  return COVERAGE_CATALOG[line].filter(def => coverageIncluded(line, level, def)).slice(0, 5).map(def => def.name);
}
